import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, X } from 'lucide-react';
export function ForWhom() {
  const isFor = ['Mujeres de más de 40 años que sienten su abdomen rígido e hinchado a diario.', 'Aquellas que sufren de "neblina mental" y cansancio extremo por la tarde.', 'Mujeres que han intentado todo y sienten que su metabolismo se "rompió".', 'Quienes buscan una solución real, práctica y adaptada a la vida en Argentina.'];
  const isNotFor = ['Personas que buscan una pastilla mágica para bajar 10 kilos en tres días.', 'Quienes no estén dispuestas a cambiar el café en ayunas por un hábito sanador.', 'Hombres o adolescentes (el protocolo es hormonalmente específico para mujeres 40+).'];
  return <section className="py-20 md:py-32" data-id="element-69">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-70">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-20" data-id="element-71">
          {/* Who is it for */}
          <div data-id="element-72">
            <FadeIn data-id="element-73">
              <h3 className="font-serif text-2xl md:text-3xl text-teal mb-8 flex items-center gap-3" data-id="element-74">
                <span className="w-8 h-8 rounded-full bg-teal/10 flex items-center justify-center text-teal" data-id="element-75">
                  <Check size={18} strokeWidth={2} data-id="element-76" />
                </span>
                Para quién es
              </h3>
              <ul className="space-y-6" data-id="element-77">
                {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-78">
                    <Check className="text-gold flex-shrink-0 mt-1" size={20} strokeWidth={1.5} data-id="element-79" />
                    <p className="text-teal/80 font-light leading-relaxed" data-id="element-80">
                      {item}
                    </p>
                  </li>)}
              </ul>
            </FadeIn>
          </div>

          {/* Who is it not for */}
          <div data-id="element-81">
            <FadeIn delay={0.2} data-id="element-82">
              <h3 className="font-serif text-2xl md:text-3xl text-teal/60 mb-8 flex items-center gap-3" data-id="element-83">
                <span className="w-8 h-8 rounded-full bg-teal/5 flex items-center justify-center text-teal/40" data-id="element-84">
                  <X size={18} strokeWidth={2} data-id="element-85" />
                </span>
                Para quién NO es
              </h3>
              <ul className="space-y-6" data-id="element-86">
                {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4 opacity-70" data-id="element-87">
                    <X className="text-teal/40 flex-shrink-0 mt-1" size={20} strokeWidth={1.5} data-id="element-88" />
                    <p className="text-teal/80 font-light leading-relaxed" data-id="element-89">
                      {item}
                    </p>
                  </li>)}
              </ul>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}